import { Action } from "@reduxjs/toolkit";
import { MapImage, Token, MapShape } from "../map/mapReducer";
import { Rootstate } from "../../store";

export interface DraggedObjectDetails {
    token: Token,
    startX: number,
    startY: number,
    rotate: number,
}

export interface DraggedImageDetails {
    image: MapImage,
    startX: number,
    startY: number,
    rotate: number
}

export interface DraggedSpellDetails {
    shape: MapShape,
    startX: number,
    startY: number,
    rotate: number,
}
export interface MoveTokenObject  {
    type: 'move-token',
    details: DraggedObjectDetails,
    onDrop?: () => void,
    onCancel?: () => void,
}

export interface MoveMapImageObject {
    type: 'move-map-image',
    details: DraggedImageDetails,
    onDrop?: () => void,
    onCancel?: () => void,
}

export interface MoveSpellobject {
    type: 'move-spell',
    details: DraggedSpellDetails,
    onDrop?: () => void,
    onCancel?: () => void,
}

export type DraggableObject = MoveTokenObject | MoveMapImageObject | MoveSpellobject | undefined
const defaultState: {
    dragging: boolean,
    draggedObject: DraggableObject,
    onDrop?: () => void,
    onCancel?: () => void,
}
 = {
     dragging: false,
     draggedObject: undefined,
 };
interface DragReducerAction extends Action {
  dragging: boolean,
  draggedObject: DraggableObject | undefined,
  onDrop?: () => void,
  onCancel?: () => void,
}


const dragReducer = (state = defaultState, action: DragReducerAction): typeof defaultState => {
    switch (action.type) {
    case 'DRAG/SET_DRAGGING':
        return {
            ...state,
            dragging: action.dragging,
            draggedObject: action.draggedObject,
            onDrop: action.onDrop,
            onCancel: action.onCancel,
        };
    case 'DRAG/STOP_DRAGGING':
        return {
            ...state,
            dragging: false,
            draggedObject: undefined,
        };
    default:
        return state;
    }
};

export const dragSelector = (state: Rootstate) => state.drag;

export default dragReducer;

